<template lang="html">
  <div class="agent-detail-user-list--inner">
    <div class="agent-details-toolbar">
      <div class="agent-details-toolbar__items">
        <select-list
          class="toolbar-nav"
          :title="$route.params.subtype"
          v-model="selectedType"
        >
          <select-option
            value="all"
            name="all"
          >
              <span>all</span>
          </select-option>

          <select-option
            value="confirmed"
            name="confirmed"
          >
              <span>confirmed</span>
          </select-option>

          <select-option
            value="rejected"
            name="rejected"
          >
              <span>rejected</span>
          </select-option>

          <select-option
            value="pending"
            name="pending"
          >
              <span>pending</span>
          </select-option>

          <select-option
            value="waiting"
            name="waiting"
          >
              <span>waiting</span>
          </select-option>
          <select-option
            value="banned"
            name="ban"
          >
              <span>ban</span>
          </select-option>
          <select-option
            value="deleted"
            name="deleted"
          >
              <span>deleted</span>
          </select-option>
        </select-list>
        <select-list class="toolbar-nav-status" :title="$route.params.status" v-model="selectedStatus">
         <select-option value="all" name="all">
            <span>all</span>
          </select-option>
          <select-option value="1" name="normal">
            <span>normal</span>
          </select-option>
          <select-option value="2" name="vip">
            <span>vip</span>
          </select-option>
          <select-option value="3" name="vipp">
            <span>vipp</span>
          </select-option>
        </select-list>
        <search
          class="search-bar-wrap"
          :filterBy="filterBy"
          :dateBy="dateBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
      </div>
    </div>

    <check-data-list
      label="loading"
      v-if="isDataLoading || isEmpty"
      :isLoading="isDataLoading"
      :isEmpty="isEmpty"
    >
    </check-data-list>
    <tbl
      :class="{'data-loading': showDataLoading}"
      :scrollable="true"
      v-else
    >
      <tbl-inner>
        <tbl-head>
          <tbl-row>
            <tbl-td
              :sort="true"
              @click.native="sort('id')"
              name="no">
              no
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('created_at')"
              name="created-at">
              created at
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('login_id')"
              name="login-id">
              login id
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('login_name')"
              name="login-name">
              login name
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('amount')"
              name="money">
              money
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('total_bet')"
              name="total-bet">
              total bet
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('total_win')"
              name="total-win">
              total win
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('total_net')"
              name="total-net">
              total net
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('status')"
              name="status">
              status
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('deleted_at')"
              name="deleted-at">
              deleted at
            </tbl-td>

          </tbl-row>
        </tbl-head>
        <tbl-body>
          <tbl-row
            v-for="user in agentUsers"
            :key="user.id"
          >
            <tbl-td name="no">
            	{{user.id}}
            </tbl-td>

            <tbl-td name="created-at">
            	{{user.created_at | date}}
            </tbl-td>

            <tbl-td name="login-id">
            	{{user.login_id}}
            </tbl-td>

            <tbl-td name="login-name">
            	{{user.login_name}}
            </tbl-td>

            <tbl-td name="money">
            	{{user.amount}}
            </tbl-td>

            <tbl-td name="total-bet">
            	{{user.total_bet}}
            </tbl-td>

            <tbl-td name="total-win">
            	{{user.total_win}}
            </tbl-td>

            <tbl-td name="total-net">
            	{{user.total_net}}
            </tbl-td>

            <tbl-td name="status">
            	{{user.status}}
            </tbl-td>

            <tbl-td name="deleted-at">
            	{{user.deleted_at | date}}
            </tbl-td>

          </tbl-row>
        </tbl-body>
      </tbl-inner>
      <tbl-footer>
        <pagination
          :total="agentUsersCnt"
          v-model="params.page"
          :rows="params.rows"
          @page="trigger"
        >
        </pagination>
      </tbl-footer>
    </tbl>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import Pagination from '@/components/base/Pagination'

export default {
  name: 'agent-detail-user-list',

  components: {
  	Search,
  	CheckDataList,
  	Pagination
  },

  mixins: [
    getListStatus
  ],

  computed: {
  	...mapState('agent', ['agentUsers', 'agentUsersCnt'])
  },

  data () {
    let params = Object.assign(
      {
        rows: 20,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )
  	return {
      selectedList: 'all',
  		params,
      filterBy: [
        {
          value: 'login_id',
          display: 'login id'
        },

        {
          value: 'login_name',
          display: 'login name'
        },

        {
          value: 'amount',
          display: 'balance'
        },

        {
          value: 'bank_account_name',
          display: 'bank account name'
        },

        {
          value: 'bank_number',
          display: 'bank account number'
        },

        {
          value: 'bank_name',
          display: 'bank name'
        },

        {
          value: 'point',
          display: 'points'
        },

        {
          value: 'code',
          display: 'codes'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        },

        {
          value: 'updated_at',
          display: 'updated at'
        }
      ],

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false
  	}
  },

  created () {
  	this.search(this.generate(this.params))
  },

  watch: {
    async '$route' ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.params = this.generate($router.query)
      this.params.rows = 20
      this.search()
    }
  },
  methods: {
  	...mapActions('agent', ['getUserList']),

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    }, // trigger
  	async search (query) {
      this.params = query || this.params

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }
  		await this.getUserList({
        id: this.$route.params.id,
        params: this.params,
        status: this.$route.params.subtype,
        vip : this.$route.params.status
      })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.agentUsers.length) {
        this.isEmpty = true
      }
  	},
    async sort (sortBy) {
      console.log('sorting ........')
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getUserList({
        id: this.$route.params.id,
        vip : this.$route.params.status,
        params: this.params,
        status: this.$route.params.subtype
      })
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.agentUsers.length) {
        this.isEmpty = true
      }
    },
  	clear () {}
  }
}
</script>
